import React, { useEffect, useState } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CloseButton,
  TextAreaInput,
  TextInputField,
} from "../../../../../../components/atoms";
import { TextDisplayOnly } from "../../../../../../components";

const CreatePrescriptionPopUp = ({
  display,
  setRequestedPrescriptionData,
  setSelectedPatientrequest,
  setLoading,
  refresh,
  setRefresh,
  selectedPatientRequest,
  admin,
  setMessage,
  setToastPop,
}) => {
  const [prescription, setPrescription] = useState("");
  const [reason, setReason] = useState("");
  const [valid, setValidUnitl] = useState("");
  const CreatePrescription = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://merry-jane-api.onrender.com/requestPrescriptionUser/createPrescription",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            idDoc: selectedPatientRequest.patientId,
            requestId: selectedPatientRequest.requestId,
            prescrip: prescription,
            reason: reason,
            docUserId: admin.userId,
            validUntil: valid,
            requestId: selectedPatientRequest.requestId,
          }),
        }
      );

      const responseData = await response.json();
      if (responseData.success) {
        setLoading(false);
        setMessage(responseData.success);
        setToastPop(true);
        setRequestedPrescriptionData(false);
        setRefresh(refresh ? false : true);
      } else {
        setLoading(false);
        setMessage(responseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const ClearData = () => {
    setPrescription("");
    setValidUnitl("");
    setReason("");
  };

  useEffect(() => {
    if (selectedPatientRequest) {
      setReason(selectedPatientRequest.requestReason);
    } else {
      ClearData();
    }
  }, [display]);
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: BlackAndWhite.secondary,
        bottom: 0,
        display: "flex",
        position: "absolute",
        transition: "all 0.3s",
        flexDirection: "row",
        // marginBottom: 40,
        justifyContent: "center",
        alignItems: "flex-start",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CloseButton
          label={"X"}
          onClick={() => {
            setRequestedPrescriptionData(false);
            ClearData();
          }}
        />
        <div style={{ marginLeft: 20, fontSize: 18, fontWeight: "bold" }}>
          CREATE NEW PRESCRIPTION
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"APPROVE PRESCRIPTION"}
          mini={true}
          //   marginTopFalse={true}
          marginTop={-5}
          borderRadius={8}
          height={40}
          size={220}
          onClick={() => CreatePrescription()}
        />
      </div>
      <div style={{ flex: 0.5, display: "flex", flexDirection: "column" }}>
        <div style={{ minHeight: 100 }} />
        <TextInputField
          mini={true}
          labelTitle={"PATIENT ID ( AUTO GENERATED )"}
          readOnly={true}
          invert={true}
          width={"100%"}
          size={"80%"}
          value={
            selectedPatientRequest
              ? selectedPatientRequest.patientId
              : "loading"
          }
        />
        <div style={{ minHeight: 10 }} />
        <TextAreaInput
          mini={true}
          labelTitle={"DIAGNOSIS"}
          //   readOnly={true}
          invert={true}
          width={"100%"}
          size={"82%"}
          color={BlackAndWhite.primary}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <div style={{ minHeight: 10 }} />
        <TextAreaInput
          mini={true}
          labelTitle={"PRESCRIPTION"}
          invert={true}
          width={"100%"}
          size={"82%"}
          color={BlackAndWhite.primary}
          value={prescription}
          onChange={(e) => setPrescription(e.target.value)}
        />
        <TextInputField
          mini={true}
          labelTitle={"VALID UNTIL"}
          //   readOnly={true}
          invert={true}
          width={"100%"}
          size={"80%"}
          value={valid}
          onChange={(e) => setValidUnitl(e.target.value)}
        />
      </div>
    </div>
  );
};

export default CreatePrescriptionPopUp;
